import app from 'flarum/forum/app';
app.initializers.add('val-ui-back-to-top', () => {
  const BUTTON_ID = 'val-back-to-top';
  const STYLE_ID = 'val-back-to-top-style';
  const SHOW_AFTER = 450;
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${BUTTON_ID} {
        position: fixed;
        right: 22px;
        bottom: 22px;
        z-index: 1040;
        width: 40px;
        height: 40px;
        padding: 0;
        border: 1px solid color-mix(in srgb, var(--muted-color) 32%, transparent);
        border-radius: 50%;
        background: color-mix(in srgb, var(--body-bg) 92%, var(--control-bg));
        color: var(--text-color);
        box-shadow: 0 2px 10px rgba(0, 0, 0, .16);
        font: inherit;
        font-size: 25px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        opacity: 0;
        visibility: hidden;
        transform: translateY(6px);
        transition: opacity .16s ease, transform .16s ease, visibility .16s ease,
                    background-color .16s ease;
      }

      #${BUTTON_ID}.is-visible {
        opacity: .86;
        visibility: visible;
        transform: translateY(0);
      }

      #${BUTTON_ID}:hover,
      #${BUTTON_ID}:focus-visible {
        opacity: 1;
        background: var(--control-bg);
      }

      #${BUTTON_ID}:focus-visible {
        outline: 2px solid var(--primary-color);
        outline-offset: 2px;
      }

      @media (max-width: 767px) {
        #${BUTTON_ID} {
          right: 14px;
          bottom: calc(14px + env(safe-area-inset-bottom, 0px));
          width: 38px;
          height: 38px;
          font-size: 24px;
          line-height: 34px;
        }
      }
    `;
    document.head.appendChild(style);
  }
  let button = document.getElementById(BUTTON_ID);
  if (!button) {
    button = document.createElement('button');
    button.id = BUTTON_ID;
    button.type = 'button';
    button.textContent = '↑';
    button.title = 'Remonter en haut de la page';
    button.setAttribute('aria-label', 'Remonter en haut de la page');
    button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    document.body.appendChild(button);
  }
  let ticking = false;
  const refresh = () => {
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    button.classList.toggle('is-visible', y > SHOW_AFTER);
    ticking = false;
  };
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(refresh);
  };
  window.addEventListener('scroll', onScroll, {
    passive: true
  });
  refresh();
});